/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Rights_Erasure_DescInputs */

const es_privacy_policy_rights_erasure_desc = /** @type {(inputs: Privacy_Policy_Rights_Erasure_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitar la eliminacion de su informacion personal`)
};

const en_privacy_policy_rights_erasure_desc = /** @type {(inputs: Privacy_Policy_Rights_Erasure_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request deletion of your personal information`)
};

/**
* | output |
* | --- |
* | "Request deletion of your personal information" |
*
* @param {Privacy_Policy_Rights_Erasure_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_rights_erasure_desc = /** @type {((inputs?: Privacy_Policy_Rights_Erasure_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Rights_Erasure_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_rights_erasure_desc(inputs)
	return en_privacy_policy_rights_erasure_desc(inputs)
});
export { privacy_policy_rights_erasure_desc as "privacy_policy.rights.erasure_desc" }